module.exports = __webpack_public_path__ + "img/fronx-ta-fox.22a20274.png";